<template>
  <div class="container mt-5">
    <b-card class="text-center">
      <h1>Processing Request</h1>
      <p>Please wait while we process your request...</p>
      <form :action="reqUrl" method="post" id="pgrequest" ref="pgrequest" hidden>
        <input type="hidden" name="msg" :value="messageToSend" />
        <input type="submit" id="submit" hidden />
      </form>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      reqUrl: "", 
      messageToSend: "" 
    };
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    this.reqUrl = urlParams.get("reqUrl");
    this.messageToSend = urlParams.get("messageToSend");

    this.$nextTick(() => {
      const form = this.$refs.pgrequest;
      if (form && form.tagName === "FORM") {
        document.getElementById("submit").click();
      } else {
        console.error("Form not found or not a valid FORM element.");
      }
    });
  }
};
</script>

<style scoped>
.container {
  max-width: 600px;
}
</style>
